module.exports = __webpack_public_path__ + "static/media/email-white.fbe14829.svg";